import { Card } from '@/components/ui/card'
import { cn } from '@/utils/cn'

interface DocsScreenshotProps {
  src: string
  alt: string
  caption?: string
  className?: string
}

export function DocsScreenshot({ src, alt, caption, className }: DocsScreenshotProps) {
  return (
    <figure className={cn('my-8', className)}>
      <Card className="rounded-lg overflow-hidden p-0">
        <img src={src} alt={alt} className="w-full h-auto" loading="lazy" />
      </Card>
      {caption && (
        <figcaption className="mt-3 text-center text-sm text-muted-foreground italic">
          {caption}
        </figcaption>
      )}
    </figure>
  )
}
